import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceSettingsEntityState} from "../reducers/ecommerce-settings.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceSettingsState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceSettings.entities[websiteId]);

export const getSettings = (websiteId: number) => createSelector(getEcommerceSettingsState(websiteId),
  (state: IEcommerceSettingsEntityState) => {
    return state.settings;
  }
);

export const getSettingsLoading = (websiteId: number) => createSelector(getEcommerceSettingsState(websiteId),
  (state: IEcommerceSettingsEntityState) => state && state.loading
);
